// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Operations-page {
    width: 100%;
    padding: 2rem 3.5rem;
}

.status-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    background-color: white;
    width: fit-content;
    padding: 1rem;
    border-radius: 50px;
}

.Operations-section {
    margin-top: 3rem;
}

/* .Operations-page h2 {
  font-size:3.2rem;
} */

/* .tableau-de-bord-section {
    border: 2px solid #2C3948;
    border-radius: 10px;
    padding: 2rem;
} */

.tableau-de-bord-section h1 {
  margin-bottom: 2rem;
}

.page-header.client-view .buttons-container {
  /* display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  width: 100%; */
}

.page-header .buttons-container {
    /* margin: 0 0 2.5rem 0; */
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.page-header.client-view {
  /* flex-direction: column; */
  /* align-items: flex-start; */
  gap: 2rem;
  width: 100%;
}

.montant-operation {
  font-weight:700;
  text-align: right !important;
  white-space: nowrap;
}
/* new styles */

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 1.2rem;
  border-radius: 2rem;
  font-size: 1.4rem;
  font-weight: 700;
}

.status-badge.accepté {
  color: #00A708;
}

.status-badge.brouillons {
  color: #6B7280;
}

.status-badge.action-requise {
  color: #F4751B;
}

.status-badge.refusé {
  color: #D90E0E;
}

.status-badge.expiré {
  color: #D90E0E;
}

.status-badge.en-attente {
  color: #6B7280;
}

.status-badge.inconnu {
  color: #E5E7EB;
}

.tableau-container {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.tableau th {
  padding: 1rem;
  background-color: #f9f9f9;
  position: relative;
  cursor: pointer;
}

.sort-icon {
  position: absolute;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
}

.action-button {
  border-radius: 20px;
  padding: 8px 20px;
  font-weight: 600;
}

.action-button.action-requise {
  background-color: #DA7027;
  color: #FFFDFC;
  border: none
}

.action-button.action-requise:hover {
  background-color: #B24C26;
  color: #FFFDFC;
  border: none;
}

.countdown {
  color: #DA7027;
  font-weight: 600;
}

td .action-button {
  font-size: 1.2rem !important;
  width: 140px;
}

td .countdown {
  border-width: 1px !important;
  font-size: 1.1rem;
  white-space: nowrap;
}

td .Operation-nom {
  min-width: 150px;
}

/* Style pour tronquer le texte qui dépasse */
.lot-technique.text-truncate {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* Ajoutez un titre (tooltip) qui apparaît au survol pour voir le texte complet */
.lot-technique.text-truncate:hover {
  position: relative;
}

/* Ajouter à Operations.css */
.text-truncate {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  max-height: 2.8em; /* ~2 lines */
  line-height: 1.4em;
}

.client-info,
.lot-technique,
.lot-geographique,
.user-info,
.Operation-nom,
.date-info,
.type-info {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-height: 1.4em;
}

.tableau-container td {
  vertical-align: top;
  padding: 8px 12px;
}

/* Pour assurer que les points de suspension s'affichent correctement */
.tableau-container td > div {
  position: relative;
  width: 100%;
}

td .button {
  padding: 0.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Operation/Operation.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;GAEG;;AAEH;;;;GAIG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;gBAIc;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,eAAe;;AAEf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".Operations-page {\r\n    width: 100%;\r\n    padding: 2rem 3.5rem;\r\n}\r\n\r\n.status-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n    background-color: white;\r\n    width: fit-content;\r\n    padding: 1rem;\r\n    border-radius: 50px;\r\n}\r\n\r\n.Operations-section {\r\n    margin-top: 3rem;\r\n}\r\n\r\n/* .Operations-page h2 {\r\n  font-size:3.2rem;\r\n} */\r\n\r\n/* .tableau-de-bord-section {\r\n    border: 2px solid #2C3948;\r\n    border-radius: 10px;\r\n    padding: 2rem;\r\n} */\r\n\r\n.tableau-de-bord-section h1 {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.page-header.client-view .buttons-container {\r\n  /* display: flex;\r\n  gap: 1rem;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%; */\r\n}\r\n\r\n.page-header .buttons-container {\r\n    /* margin: 0 0 2.5rem 0; */\r\n}\r\n\r\n.page-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.page-header.client-view {\r\n  /* flex-direction: column; */\r\n  /* align-items: flex-start; */\r\n  gap: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n.montant-operation {\r\n  font-weight:700;\r\n  text-align: right !important;\r\n  white-space: nowrap;\r\n}\r\n/* new styles */\r\n\r\n.status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0.4rem 1.2rem;\r\n  border-radius: 2rem;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.status-badge.accepté {\r\n  color: #00A708;\r\n}\r\n\r\n.status-badge.brouillons {\r\n  color: #6B7280;\r\n}\r\n\r\n.status-badge.action-requise {\r\n  color: #F4751B;\r\n}\r\n\r\n.status-badge.refusé {\r\n  color: #D90E0E;\r\n}\r\n\r\n.status-badge.expiré {\r\n  color: #D90E0E;\r\n}\r\n\r\n.status-badge.en-attente {\r\n  color: #6B7280;\r\n}\r\n\r\n.status-badge.inconnu {\r\n  color: #E5E7EB;\r\n}\r\n\r\n.tableau-container {\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.tableau th {\r\n  padding: 1rem;\r\n  background-color: #f9f9f9;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.sort-icon {\r\n  position: absolute;\r\n  right: -1px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.action-button {\r\n  border-radius: 20px;\r\n  padding: 8px 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.action-button.action-requise {\r\n  background-color: #DA7027;\r\n  color: #FFFDFC;\r\n  border: none\r\n}\r\n\r\n.action-button.action-requise:hover {\r\n  background-color: #B24C26;\r\n  color: #FFFDFC;\r\n  border: none;\r\n}\r\n\r\n.countdown {\r\n  color: #DA7027;\r\n  font-weight: 600;\r\n}\r\n\r\ntd .action-button {\r\n  font-size: 1.2rem !important;\r\n  width: 140px;\r\n}\r\n\r\ntd .countdown {\r\n  border-width: 1px !important;\r\n  font-size: 1.1rem;\r\n  white-space: nowrap;\r\n}\r\n\r\ntd .Operation-nom {\r\n  min-width: 150px;\r\n}\r\n\r\n/* Style pour tronquer le texte qui dépasse */\r\n.lot-technique.text-truncate {\r\n  max-width: 100px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n}\r\n\r\n/* Ajoutez un titre (tooltip) qui apparaît au survol pour voir le texte complet */\r\n.lot-technique.text-truncate:hover {\r\n  position: relative;\r\n}\r\n\r\n/* Ajouter à Operations.css */\r\n.text-truncate {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  max-height: 2.8em; /* ~2 lines */\r\n  line-height: 1.4em;\r\n}\r\n\r\n.client-info,\r\n.lot-technique,\r\n.lot-geographique,\r\n.user-info,\r\n.Operation-nom,\r\n.date-info,\r\n.type-info {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  line-height: 1.4em;\r\n}\r\n\r\n.tableau-container td {\r\n  vertical-align: top;\r\n  padding: 8px 12px;\r\n}\r\n\r\n/* Pour assurer que les points de suspension s'affichent correctement */\r\n.tableau-container td > div {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\ntd .button {\r\n  padding: 0.5rem !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
